// import styled from "styled-components";
import { styledByTheme } from "../../../../../../themes/architecture/styled-by-theme";
import { DepositSideMenuItemIconBox } from "../deposit/deposit-side-menu-item-icon.box";

// const SignupSideMenuItemIconSiBox = styled(DepositSideMenuItemIconBox)`
//     font-size: 1.6rem;
//     color: ${({theme}) => theme.colors.moneyColor };
// `;

export const SignupSideMenuItemIconBox = styledByTheme(DepositSideMenuItemIconBox)
    // .forSI(SignupSideMenuItemIconSiBox)
    .apply();
